import React from 'react'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import KeyboardDoubleArrowLeft from '@mui/icons-material/KeyboardDoubleArrowLeft'
import KeyboardDoubleArrowRight from '@mui/icons-material/KeyboardDoubleArrowRight'
import LoadingSpinner from './LoadingSpinner'

const btnStyle = (disabled) => ({    position: 'relative',
    background: 'var(--dark-gray)',
    border: '1px solid transparent',
    color: 'var(--text-light)',
    padding: '8px',
    borderRadius: 'var(--radius-sm)',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: 'var(--text-sm)',
    minWidth: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: disabled ? 0.5 : 1
})

/** Текст диапазона «1-10 of N» для футера таблицы. */
export function PaginationRangeText({ page, rowsPerPage, count }) {
    const safePage = isNaN(page) ? 0 : page
    const safeRowsPerPage = isNaN(rowsPerPage) ? 10 : rowsPerPage
    const safeCount = isNaN(count) ? 0 : count
    const start = safePage * safeRowsPerPage + 1
    const end = Math.min((safePage + 1) * safeRowsPerPage, safeCount)

    return (
        <span className="pagination-actions__text">
            {start}-{end} of {safeCount}
        </span>
    )
}

/** Десктопная пагинация: first / prev / label / next / last. */
export default function PaginationActions({
    page,
    rowsPerPage,
    count,
    onPageChange,
    loadingButton,
    pageAction = false,
    centerLabel = 'pages'
}) {
    const safePage = isNaN(page) ? 0 : page
    const safeRowsPerPage = isNaN(rowsPerPage) ? 10 : rowsPerPage
    const safeCount = isNaN(count) ? 0 : count

    const totalPages = safeRowsPerPage === 0 ? 0 : Math.ceil(safeCount / safeRowsPerPage)

    const goTo = (newPage, action) => {
        if (pageAction) {
            onPageChange(null, newPage, action)
        } else {
            onPageChange(null, newPage)
        }
    }

    const handleFirstPage = () => goTo(0, 'first')
    const handlePrevPage = () => goTo(Math.max(0, safePage - 1), 'prev')
    const handleNextPage = () => goTo(Math.min(totalPages - 1, safePage + 1), 'next')
    const handleLastPage = () => goTo(Math.max(0, totalPages - 1), 'last')

    const isFirstDisabled = safePage === 0 || loadingButton
    const isLastDisabled = safePage >= totalPages - 1 || loadingButton

    const centerText = centerLabel === 'range'
        ? `${isNaN(page) ? 0 : page * rowsPerPage + 1}-${Math.min((page + 1) * rowsPerPage, safeCount)} of ${safeCount}`
        : `${safePage + 1} of ${totalPages}`

    return (
        <div className="pagination-actions" style={{ display: 'flex', gap: '4px' }}>
            <button
                type="button"
                className="gold-gradient-border pagination-actions__btn"
                style={btnStyle(isFirstDisabled)}
                onClick={handleFirstPage}
                disabled={isFirstDisabled}
            >
                {loadingButton === 'first' ? <LoadingSpinner /> : <KeyboardDoubleArrowLeft className="pagination-actions__icon" style={{ fontSize: '14px', fill: 'url(#goldGradient)' }} />}
            </button>
            <button
                type="button"
                className="gold-gradient-border pagination-actions__btn"
                style={btnStyle(isFirstDisabled)}
                onClick={handlePrevPage}
                disabled={isFirstDisabled}
            >
                {loadingButton === 'prev' ? <LoadingSpinner /> : <KeyboardArrowLeft className="pagination-actions__icon" style={{ fontSize: '14px', fill: 'url(#goldGradient)' }} />}
            </button>
            <span className="pagination-actions__text pagination-actions__text--center">
                {centerText}
            </span>
            <button
                type="button"
                className="gold-gradient-border pagination-actions__btn"
                style={btnStyle(isLastDisabled)}
                onClick={handleNextPage}
                disabled={isLastDisabled}
            >
                {loadingButton === 'next' ? <LoadingSpinner /> : <KeyboardArrowRight className="pagination-actions__icon" style={{ fontSize: '14px', fill: 'url(#goldGradient)' }} />}
            </button>
            <button
                type="button"
                className="gold-gradient-border pagination-actions__btn"
                style={btnStyle(isLastDisabled)}
                onClick={handleLastPage}
                disabled={isLastDisabled}
            >
                {loadingButton === 'last' ? <LoadingSpinner /> : <KeyboardDoubleArrowRight className="pagination-actions__icon" style={{ fontSize: '14px', fill: 'url(#goldGradient)' }} />}
            </button>
        </div>
    )
}
